import React from 'react';
import ReactDOM from 'react-dom';
import './assets/common.less';
import App from './components/App';
import store from './store/index';
import { Provider } from 'mobx-react';

ReactDOM.render(
  <Provider {...store}>
    <App />
  </Provider>,
  document.querySelector('.root')
);



// WEBPACK FOOTER //
// ./src/index.js